module.exports = __webpack_public_path__ + "assets/2_1_2_IFOK_WIM_SOUVERENITY_SAVETY_platform_for_svg_je.0b8022b1.svg";